import type { FC } from 'react';
import { DrawerSection } from '@components/DrawerSection';
import InputSelect from '@components/InputSelect';
import InputText from '@components/InputText';
import { Show, ShowFirstMatching } from '@components/Show';
import type { BlockEditFormState } from '@ContractBuilder/modules/block-edit';
import { CLAUSE_CLASSIFICATIONS, CLAUSE_TYPES } from '@root/helpers';

import { useBlockPanelContent } from '../hooks/useBlockPanelContent';
import type { BlockEditFormSetter } from '../types';
import { shouldRenderField } from '../utils/should-render-field';

interface ClauseDetailsProps {
  formValues?: BlockEditFormState;
  isAdminView: boolean;
  isBlockType: boolean;
  setFormValues: BlockEditFormSetter;
}

export const ClauseDetails: FC<ClauseDetailsProps> = ({ formValues, isAdminView, isBlockType, setFormValues }) => {
  const { getContent } = useBlockPanelContent(isBlockType);

  return (
    <>
      <DrawerSection title={getContent('fields.reference.label')}>
        <InputText
          labelText=""
          placeholder={getContent('fields.reference.placeholder')}
          name="clause_reference"
          value={formValues?.clause_reference}
          onChange={(event) => setFormValues((prev) => ({ ...prev, clause_reference: event.target.value }))}
          dataTestId="text:clause-reference"
        />
      </DrawerSection>
      <DrawerSection title={getContent('fields.type.label')}>
        <InputSelect
          labelText=""
          dataTestId="select:clause-type"
          options={CLAUSE_TYPES.map((label) => ({ name: label, value: label }))}
          name="clause_type"
          value={formValues?.clause_type}
          onChange={(value) => setFormValues((prev) => ({ ...prev, clause_type: value }))}
        />
      </DrawerSection>
      <Show when={shouldRenderField(isAdminView, formValues?.classification)}>
        <DrawerSection title={getContent('fields.classification.label')}>
          <ShowFirstMatching>
            <Show when={isAdminView}>
              <InputSelect
                isClearable
                labelText=""
                dataTestId="select:classification"
                options={CLAUSE_CLASSIFICATIONS.map((label) => ({ name: label, value: label }))}
                name="classification"
                value={formValues?.classification}
                onChange={(value) => setFormValues((prev) => ({ ...prev, classification: value }))}
              />
            </Show>
            <Show when={!isAdminView}>
              <p className="text-info-800 text-sm">{formValues?.classification}</p>
            </Show>
          </ShowFirstMatching>
        </DrawerSection>
      </Show>
    </>
  );
};
